module.exports = __webpack_public_path__ + "components/outside-promo-page/static/runners-259e717a2ae6f3f1de5837f6ab6eee37.webp";